module.exports = __webpack_public_path__ + "static/media/menu-icon.e02150a9.svg";